import { useMemo } from 'react';

import { usePageTheme } from './useWebsiteTheme';

export const usePageColors = (styles) => {
    const { theme } = usePageTheme();

    return useMemo(() => {
        const backgroundColor = styles && styles.backgroundColor;
        const color = styles && styles.color;

        return backgroundColor && color
            ? styles
            : {
                backgroundColor: backgroundColor || theme.colors.background,
                color: color || theme.colors.text,
            };
    }, [styles, theme.colors]);
};
